import Logger from './logger'
import config from './config'

window.GitHub = window.GitHub || {}
window.Render = window.Render || {}

// Try to call `console.log`, if possible, in the way
// most likely to invoke pretty-printing
function safeLog(...args) {
  if (!('log' in window.console)) {
    return
  }

  return window.console.log(...args)
}

const logger = new Logger({
  loggerFn: safeLog,
  quiet: config.quiet
})
window.debug = logger.debug.bind(logger)
window.debug.buffer = () => logger.buffer

// load files from this directory into webpack (everything in ./ that ends in js and isn't this file
const renderFilesRequire = require.context('./', true, /(?<!index)^(?!.*\.test\.js$).*\.js$/)

for (const key of renderFilesRequire.keys()) {
  renderFilesRequire(key)
}
